import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Navbar from "../../Components/Navbar/Navbar";
import Dropdown from "../Dropdown/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./editprofile.css";
import "./availabilty.css";
import MultiSelect from "./components/MultiSelect";
import { serviceImagePost, servicePost } from "../../helper/api";
import moment from "moment/moment";
import TimePicker from "./components/TimePicker";
import Button from "../../Components/UIComponents/Button";
import AvailabiltyDrawer from "../Drawers/AvailabiltyDrawer";
import CommericalDrawer from "../Drawers/CommericalDrawer";
import ResidentialDrawer from "../Drawers/ResidentialDrawer";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setResidentailServices,
  setResidentailSpeciality,
  setSelectedServices,
  setSelectedSpeciality,
} from "../../redux/features/servicesSlice";
import { convertTo12HourFormat } from "../../helper/helper";
import StatusChangeModal from "../Modals/StatusChangeModal";
import CommonModal from "../Modals/CommonModal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import InputField from "../../Components/UIComponents/InputField";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { validFileSize, validFileTypes } from "../../helper/utility";

// Status DropDown Data
const ApplicationStatusDropdown = [
  {
    name: "Approved",
  },
  {
    name: "Rejected",
  },
];

const ServicesData = [
  { id: 1, name: "Toronto" },
  { id: 2, name: "Mississauga" },
  { id: 3, name: "Brampton" },
  { id: 4, name: "Markham" },
  { id: 5, name: "Vaughan" },
  { id: 6, name: "Richmond Hill" },
  { id: 7, name: "Oakville" },
  { id: 8, name: "Burlington" },
  { id: 9, name: "Milton" },
  { id: 10, name: "Halton Hills" },
  { id: 11, name: "My City is Not Located" },
];

// Initial state with days of the week
const initialState = {
  Mo: [{ id: 1, startTime: "", endTime: "" }],
  Tu: [{ id: 1, startTime: "", endTime: "" }],
  We: [{ id: 1, startTime: "", endTime: "" }],
  Th: [{ id: 1, startTime: "", endTime: "" }],
  Fr: [{ id: 1, startTime: "", endTime: "" }],
  Sa: [{ id: 1, startTime: "", endTime: "" }],
  Su: [{ id: 1, startTime: "", endTime: "" }],
};

const daysOfWeek = {
  Mo: "M",
  Tu: "T",
  We: "W",
  Th: "T",
  Fr: "F",
  Sa: "S",
  Su: "S",
};

const EditProfile = () => {
  // Get UserDetail from state
  const location = useLocation();
  const AccountId = location?.state?.AccountId;

  const [isLoading, setIsLoading] = useState(false);
  const [shimmerLoading, setShimmerLoading] = useState(true);

  const [selectedCity, setSelectedCity] = useState([]);
  const [isInhouseChecked, setIsInhouseChecked] = useState(false);
  const [isBankChecked, setIsBankChecked] = useState(false);
  const [isCrimnalChecked, setIsCrimnalChecked] = useState(false);
  const [checkedIp, setCheckedIp] = useState("customer");
  const [selectedDate, setSelectedDate] = useState(null);
  const [userDetail, setUserDetail] = useState();
  const [bankDetail, setBankDetail] = useState("");

  const [bussinessPath, setBussinessPath] = useState("");
  const [gstPath, setGstPath] = useState("");
  const [insurancePath, setInsurancePath] = useState("");
  const [whimsPath, setWhimsPath] = useState("");

  const [ohsaCerificatePath, setOhsaCertificatePath] = useState("");
  const [bankChequePath, setBanChequePath] = useState("");
  const [crimnalCheckPath, setCrimnalCheckPath] = useState("");

  // upload document loading states
  const [docUploadLoading, setDocUploadLoading] = useState(false);
  const [businessUploadLoading, setBusinessUploadLoading] = useState(false);
  const [gstUploadLoading, setGstUploadLoading] = useState(false);
  const [liabilityUploadLoading, setLiabilityUploadLoading] = useState(false);
  const [whimsUploadLoading, setWhimsUploadLoading] = useState(false);

  const [docBankLoading, setBankLoading] = useState(false);
  const [crimnalCheckLoading, setCrimnalCheckLoading] = useState(false);

  //
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusType, setStatusType] = useState("");
  const [statusIsLoading, setStatusIsLoading] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState("");
  const [showCommanModal, setShowCommanModal] = useState(false);
  const [commanModalText, setCommanModalText] = useState();
  const [sinNumber, setSinNumber] = useState("");

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const allServices = useSelector((state) => state.allServices);
  console.log("allServices", allServices);

  const selectedComServices = allServices?.selectedServices;
  const selectedComSpeciality = allServices?.selectedSpeciality;
  const selectedResidentailServices = allServices?.selectedResidentailServices;
  const selectedResidentailSpeciality =
    allServices?.selectedResidentailSpeciality;

  const [availabiltyData, setAvailabiltyData] = useState(initialState);
  const [showAvailabityDrawer, setShowAvailabityDrawer] = useState(false);
  const handleCloseAvailabity = () => setShowAvailabityDrawer(false);
  const handleShowAvailabity = (title) => {
    setShowAvailabityDrawer(true);
  };

  const [showCommericalDrawer, setShowCommericalDrawer] = useState(false);
  const handleCloseCommerical = () => setShowCommericalDrawer(false);
  const handleShowCommerical = (title) => {
    setShowCommericalDrawer(true);
  };

  const [showResidentialDrawer, setShowResidentialDrawer] = useState(false);
  const handleCloseResidential = () => setShowResidentialDrawer(false);
  const handleShowResidential = (title) => {
    setShowResidentialDrawer(true);
  };

  const getUserDetail = async () => {
    try {
      const userDetailRes = await servicePost(
        "adminauth/contractorDetail",
        {
          accountId: AccountId,
        },
        notification,
        authToken
      );
      setShimmerLoading(false);
      setUserDetail(userDetailRes.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getUserDetail();
  }, [AccountId]);

  // Get Availability from api
  const getAvailabilityRes = async () => {
    try {
      const availabilityRes = await servicePost(
        "adminauth/getAvailability",
        {
          id: userDetail?.accountId,
        },
        notification,
        authToken
      );

      if (availabilityRes?.data?.dayTimeAvailble) {
        setAvailabiltyData(availabilityRes.data.dayTimeAvailble);
      } else {
        setAvailabiltyData(initialState); // Fallback to initial state if data is not available
      }
    } catch (error) {
      console.log("error", error);
      setAvailabiltyData(initialState); // Fallback in case of error
    }
  };

  useEffect(() => {
    getAvailabilityRes();
  }, [userDetail?.accountId, showAvailabityDrawer]);

  // Get Bank Cheque Information
  const getBankChequeDetail = async () => {
    try {
      const bankChequeRes = await servicePost(
        "adminauth/getBankingData",
        {
          id: userDetail?.accountId,
        },
        notification,
        authToken
      );
      setBanChequePath(bankChequeRes?.data?.bankCheque);
      setBankDetail(bankChequeRes?.data);
    } catch (error) {
      console.log("err", error);
    }
  };

  useEffect(() => {
    getBankChequeDetail();
  }, [userDetail?.accountId, docBankLoading]);

  // Set userDetail?.serviceCities data in selectedCity when userDetail is available
  useEffect(() => {
    if (userDetail?.serviceCities) {
      const initialSelectedCities = userDetail.serviceCities
        ?.map((cityName) => {
          const cityData = ServicesData.find(
            (service) => service.name === cityName
          );
          return cityData ? { id: cityData.id, name: cityData.name } : null;
        })
        .filter(Boolean); // Remove any null values in case there's no match

      setSelectedCity(initialSelectedCities);
    }
  }, [userDetail]);

  // Safety check for services and selectedServices
  const selectedServices =
    userDetail?.services?.[0]?.commercial?.selectedServices || [];
  const selectedSpecaility =
    userDetail?.services?.[0]?.commercial?.selectedSpecaility || [];

  const selectedResidentalServices =
    userDetail?.services?.[1]?.residential?.selectedResidentalServices || [];
  const selectedResidentalSpecaility =
    userDetail?.services?.[1]?.residential?.selectedResidentalSpecaility || [];

  const dispatch = useDispatch();

  const prevStateRef = useRef({
    selectedServices: [],
    selectedSpecaility: [],
    selectedResidentalServices: [],
    selectedResidentalSpecaility: [],
  });
  // Set Services in Redux
  useEffect(() => {
    const prevState = prevStateRef.current;
    if (
      JSON.stringify(selectedServices) !==
        JSON.stringify(prevState.selectedServices) ||
      JSON.stringify(selectedSpecaility) !==
        JSON.stringify(prevState.selectedSpecaility) ||
      JSON.stringify(selectedResidentalServices) !==
        JSON.stringify(prevState.selectedResidentalServices) ||
      JSON.stringify(selectedResidentalSpecaility) !==
        JSON.stringify(prevState.selectedResidentalSpecaility)
    ) {
      dispatch(setSelectedServices(selectedServices));
      dispatch(setSelectedSpeciality(selectedSpecaility));
      dispatch(setResidentailServices(selectedResidentalServices));
      dispatch(setResidentailSpeciality(selectedResidentalSpecaility));
      // Update the ref with current state
      prevStateRef.current = {
        selectedServices,
        selectedSpecaility,
        selectedResidentalServices,
        selectedResidentalSpecaility,
      };
    }
  }, [
    selectedServices,
    selectedSpecaility,
    selectedResidentalServices,
    selectedResidentalSpecaility,
    dispatch,
  ]);

  // Check if Values already exist
  useEffect(() => {
    if (userDetail) {
      setBussinessPath(
        !userDetail.bussinessRegistration
          ? ""
          : userDetail.bussinessRegistration
      );

      setGstPath(!userDetail.gstProof ? "" : userDetail.gstProof);
      setInsurancePath(
        !userDetail.liabilityInsurance ? "" : userDetail.liabilityInsurance
      );

      setWhimsPath(
        !userDetail.whmisRegistration ? "" : userDetail.whmisRegistration
      );
      setOhsaCertificatePath(
        !userDetail.ohsaCertificate ? "" : userDetail.ohsaCertificate
      );

      setCrimnalCheckPath(!userDetail.idProof ? "" : userDetail.idProof);
      setIsCrimnalChecked(
        !userDetail.criminalCheck ? "" : userDetail.criminalCheck
      );
      setIsInhouseChecked(userDetail.inHouseStatus == null ? false : true);

      setSinNumber(!userDetail.sin ? "" : userDetail.sin);
    }
  }, [userDetail]);

  // Check if Values already exist
  useEffect(() => {
    if (bankDetail) {
      setIsBankChecked(
        bankDetail.bankChequeStatus == "Approved" ? true : false
      );
    }
  }, [bankDetail]);

  // Go back to the profile
  const navigate = useNavigate();
  const goBackHandler = () => {
    navigate(-1);
  };

  const handleDropdownChange = (field) => (value) => {
    if (field === "ApplicationStatus") {
      setApplicationStatus(value);
      const updateApplication = servicePost(
        "adminauth/updateContractorData",
        {
          accountId: userDetail?.accountId,
          applicationStatus: value,
        },
        notification,
        authToken
      ).then((response) => {
        setCommanModalText("Application Status Updated");
        setShowCommanModal(true);
        setTimeout(() => {
          setCommanModalText("");
          setShowCommanModal(false);
        }, 2000);
      });
    }
  };

  // HandleDate Change
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // Function to toggle the checked state
  const toggleChecked = () => {
    setIsInhouseChecked(!isInhouseChecked);
    setShowStatusModal(true);
    setStatusType("InHouse");
  };

  const toggleBankApprove = () => {
    setIsBankChecked(!isBankChecked);
    setShowStatusModal(true);
    setStatusType("BankApproved");
  };

  const toggleCrimnalApprove = () => {
    setIsCrimnalChecked(!isCrimnalChecked);
    setShowStatusModal(true);
    setStatusType("CriminalApproved");
  };

  // Handle StatusModal Close
  const hanleCloseModal = () => {
    if (statusType == "InHouse") {
      setIsInhouseChecked(!isInhouseChecked);
    }
    if (statusType == "BankApproved") {
      setIsBankChecked(!isBankChecked);
    }

    if (statusType == "CriminalApproved") {
      setIsCrimnalChecked(!isCrimnalChecked);
    }
    setShowStatusModal(false);
  };

  // HandleStatus change
  const handleStatusChange = async () => {
    try {
      setStatusIsLoading(true);
      // For Change InHouseStatus
      if (statusType == "InHouse") {
        setStatusIsLoading(true);
        const updateStatusInfo = await servicePost(
          "adminauth/updateContractorInfo",
          {
            id: userDetail?.accountId,
            inHouseStatus: isInhouseChecked,
          },
          notification,
          authToken
        );
        if (updateStatusInfo.message == "SUCCESS") {
          // navigate("/service-provide-soon");
          setStatusIsLoading(false);
          setShowStatusModal(false);

          setCommanModalText("In House Status Updated");
          setShowCommanModal(true);
          setTimeout(() => {
            setShowCommanModal(false);
            setCommanModalText("");
          }, 2000);
        }
      }

      // For Change InHouseStatus
      if (statusType == "CriminalApproved") {
        const updateStatusInfo = await servicePost(
          "adminauth/updateContractorInfo",
          {
            id: userDetail?.accountId,
            criminalCheck: isCrimnalChecked,
          },
          notification,
          authToken
        );

        if (updateStatusInfo.message == "SUCCESS") {
          // navigate("/service-provide-soon");
          setStatusIsLoading(false);
          setShowStatusModal(false);
          setCommanModalText("Criminal Check Status Updated");
          setShowCommanModal(true);
          setTimeout(() => {
            setShowCommanModal(false);
            setCommanModalText("");
          }, 2000);
        }
      }

      // For ApplicationChange Status
      if (statusType == "BankApproved") {
        const updateStatusInfo = await servicePost(
          "adminauth/updatebankingDataStatus",
          {
            id: userDetail?.accountId,
            bankChequeStatus: isBankChecked,
          },
          notification,
          authToken
        );

        if (updateStatusInfo.message == "SUCCESS") {
          // navigate("/service-provide-soon");
          setStatusIsLoading(false);
          setShowStatusModal(false);
          setCommanModalText("Bank Status Updated");
          setShowCommanModal(true);
          setTimeout(() => {
            setShowCommanModal(false);
            setCommanModalText("");
          }, 2000);
        }
      }

      setStatusIsLoading(false);
    } catch (error) {
      console.log("err", error);
    }
  };

  // Handle City Select
  const handleChange = (event, type, id, name) => {
    const { checked } = event.target;
    if (type === "servicesCities") {
      if (checked) {
        setSelectedCity([...selectedCity, { id, name }]);
      } else {
        setSelectedCity(
          selectedCity.filter((service) => service.name !== name)
        );
      }
    }
  };

  // Upload files Documents
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!validFileTypes.includes(file.type)) {
        alert("Only JPG, PNG, JPEG, and PDF files are allowed!");
        return;
      }

      if (file.size > validFileSize) {
        // alert("File size must be less than 1MB.");
        alert("File size must be less than 1MB.");
        return;
      }

      setBusinessUploadLoading(true);
      try {
        const formData = new FormData();
        formData.append("image", file);
        formData.append("id", userDetail?.accountId);
        formData.append("documentname", "bussinessRegistration");
        const updateBussinessRegistration = await serviceImagePost(
          "adminauth/uploadDocumentData",
          formData,
          authToken
        );
        setBussinessPath(updateBussinessRegistration?.Imageurl);
        setBusinessUploadLoading(false);
      } catch (error) {
        console.log("error", error);
        setBusinessUploadLoading(false);
      }
    }
  };

  const handleGstChange = async (event) => {
    const file = event.target.files[0];

    // Validate file type
    if (!validFileTypes.includes(file.type)) {
      alert("Only JPG, PNG, JPEG, and PDF files are allowed!");
      return;
    }

    if (file.size > validFileSize) {
      // alert("File size must be less than 1MB.");
      alert("File size must be less than 1MB.");
      return;
    }

    setGstUploadLoading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("id", userDetail?.accountId);
      formData.append("documentname", "gstProof");
      const updateGstDoc = await serviceImagePost(
        "adminauth/uploadDocumentData",
        formData,
        authToken
      );
      setGstPath(updateGstDoc?.Imageurl);
      setGstUploadLoading(false);
    } catch (error) {
      console.log("error", error);
      setGstUploadLoading(false);
    }
  };

  const handleInsuranceChange = async (event) => {
    const file = event.target.files[0];
    // if (file) {
    //   setInsurancePath(file.name);
    // }

    // Validate file type
    if (!validFileTypes.includes(file.type)) {
      alert("Only JPG, PNG, JPEG, and PDF files are allowed!");
      return;
    }

    if (file.size > validFileSize) {
      // alert("File size must be less than 1MB.");
      alert("File size must be less than 1MB.");
      return;
    }

    setLiabilityUploadLoading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("id", userDetail?.accountId);
      formData.append("documentname", "liabilityInsurance");
      const updateGstDoc = await serviceImagePost(
        "adminauth/uploadDocumentData",
        formData,
        authToken
      );
      setInsurancePath(updateGstDoc?.Imageurl);
      setLiabilityUploadLoading(false);
    } catch (error) {
      console.log("error", error);
      setLiabilityUploadLoading(false);
    }
  };

  const handleWhimsChange = async (event) => {
    const file = event.target.files[0];
    // if (file) {
    //   setWhimsPath(file.name);
    // }

    // Validate file type
    if (!validFileTypes.includes(file.type)) {
      alert("Only JPG, PNG, JPEG, and PDF files are allowed!");
      return;
    }

    if (file.size > validFileSize) {
      // alert("File size must be less than 1MB.");
      alert("File size must be less than 1MB.");
      return;
    }

    setWhimsUploadLoading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("id", userDetail?.accountId);
      formData.append("documentname", "whmisRegistration");
      const updateWhimsDoc = await serviceImagePost(
        "adminauth/uploadDocumentData",
        formData,
        authToken
      );
      setWhimsPath(updateWhimsDoc?.Imageurl);
      setWhimsUploadLoading(false);
    } catch (error) {
      console.log("error", error);
      setWhimsUploadLoading(false);
    }
  };

  const handleOhsaFileChange = async (event) => {
    const file = event.target.files[0];
    // if (file) {
    //   setOhsaCertificatePath(file.name);
    // }

    if (file) {
      // Validate file type
      if (!validFileTypes.includes(file.type)) {
        alert("Only JPG, PNG, JPEG, and PDF files are allowed!");
        return;
      }

      if (file.size > validFileSize) {
        // alert("File size must be less than 1MB.");
        alert("File size must be less than 1MB.");
        return;
      }
      setDocUploadLoading(true);
      try {
        const formData = new FormData();
        formData.append("image", file);
        formData.append("id", userDetail?.accountId);
        formData.append("documentname", "ohsaCertificate");
        const updateOhsaCertificate = await serviceImagePost(
          "adminauth/uploadDocumentData",
          formData,
          authToken
        );
        setOhsaCertificatePath(updateOhsaCertificate?.Imageurl);
        setDocUploadLoading(false);
      } catch (error) {
        console.log("error", error);
        setDocUploadLoading(false);
      }
    }
  };

  // upload Bank Cheque Handler
  const handleBankFileChange = async (event) => {
    const file = event.target.files[0];
    // if (file) {
    //   setBanChequePath(file.name);
    // }
    if (file) {
      // Validate file type
      if (!validFileTypes.includes(file.type)) {
        alert("Only JPG, PNG, JPEG, and PDF files are allowed!");
        return;
      }

      if (file.size > validFileSize) {
        // alert("File size must be less than 1MB.");
        alert("File size must be less than 1MB.");
        return;
      }
      try {
        setBankLoading(true);
        const formData = new FormData();
        formData.append("id", userDetail?.accountId);
        formData.append("bankCheque", file);

        const bankChequeRes = await serviceImagePost(
          "adminauth/contractorBankingData",
          formData,
          authToken
        );
        console.log("bankChequeRes", bankChequeRes);

        if (bankChequeRes.message == "SUCCESS") {
          setBankLoading(false);
          setBanChequePath(file.name);
        }
        setBankLoading(false);
      } catch (error) {
        setBankLoading(false);
        console.log("err", error);
      }
    }
  };

  // upload Bank Cheque Handler
  const handleCrimnalFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!validFileTypes.includes(file.type)) {
        alert("Only JPG, PNG, JPEG, and PDF files are allowed!");
        return;
      }

      if (file.size > validFileSize) {
        // alert("File size must be less than 1MB.");
        alert("File size must be less than 1MB.");
        return;
      }

      setCrimnalCheckLoading(true);
      try {
        const formData = new FormData();
        formData.append("image", file);
        formData.append("id", userDetail?.accountId);
        formData.append("documentname", "criminalCheck");
        const updateCriminalCheck = await serviceImagePost(
          "adminauth/uploadDocumentData",
          formData,
          authToken
        );
        setCrimnalCheckPath(updateCriminalCheck?.Imageurl);
        setCrimnalCheckLoading(false);
      } catch (error) {
        console.log("error", error);
        setCrimnalCheckLoading(false);
      }
    }
  };

  const cityNames = selectedCity?.map((city) => city.name);

  // Save Contractor profile Info while Edit
  const saveProfileInfoHandler = async () => {
    try {
      console.log("selectedComServices", selectedComServices);
      setIsLoading(true);
      const updateProfileInfo = await servicePost(
        "adminauth/updateContractorInfo",
        {
          id: userDetail?.accountId,
          serviceCities: cityNames,
          sin: sinNumber,
          services: [
            {
              commercial: {
                selectedServices: selectedComServices,
                selectedSpecaility: selectedComSpeciality,
              },
            },
            {
              residential: {
                selectedResidentalServices: selectedResidentailServices,
                selectedResidentalSpecaility: selectedResidentailSpeciality,
              },
            },
          ],
        },
        notification,
        authToken
      );

      setIsLoading(false);
      if (updateProfileInfo.message == "SUCCESS") {
        // navigate("/service-provide-soon");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <CommonModal
        show={showCommanModal}
        onHide={() => setShowCommanModal(false)}
        type={commanModalText}
      />
      <StatusChangeModal
        show={showStatusModal}
        onHide={hanleCloseModal}
        handleOnClick={handleStatusChange}
        isLoading={statusIsLoading}
        icon="./assets/icons/email-confirmation.png"
        type="Are You Sure you want to Change Status ?"
        content="Your Account Successfully Created"
        showCloseIcon={true}
      />
      <Offcanvas
        className="availability-offcanvas-wrapper"
        show={showAvailabityDrawer}
        onHide={handleCloseAvailabity}
        placement="end"
      >
        <Offcanvas.Body>
          <AvailabiltyDrawer
            AccountId={userDetail?.accountId}
            data={availabiltyData}
            onHide={handleCloseAvailabity}
            title="Cart"
            iconShow={true}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="availability-offcanvas-wrapper"
        show={showCommericalDrawer}
        onHide={handleCloseCommerical}
        placement="end"
      >
        <Offcanvas.Body>
          <CommericalDrawer
            data={userDetail}
            onHide={handleCloseCommerical}
            title="Cart"
            iconShow={true}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="availability-offcanvas-wrapper"
        show={showResidentialDrawer}
        onHide={handleCloseResidential}
        placement="end"
      >
        <Offcanvas.Body>
          <ResidentialDrawer
            data={userDetail}
            onHide={handleCloseResidential}
            title="Cart"
            iconShow={true}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <Navbar />
      <div className="account-detail-main-wrapper">
        <Sidebar />
        <div className="container">
          <div className="spacing-wrapper">
            <div className="account-detail-header">
              <div className="account-header-left contractor-edit-profile">
                <img src="./images/icons/admin-user-icon.png" alt="icon" />

                <h2 className="account-detail-Txt contractor-edit-profile">
                  Account/Contractor/Profile
                </h2>
              </div>
            </div>
            <>
              <div className="account-detail-profile-wrapper">
                <div className="edit-profile-header-wrap">
                  <div className="account-profile-head">
                    <img
                      onClick={goBackHandler}
                      src="./images/icons/back-arrow.svg"
                      alt="arrow"
                    />
                    <h3> Profile</h3>
                  </div>

                  <div className="account-edit-profile-right">
                    {userDetail?.employementStatus == "employee" && (
                      <div className="inhouse-main-wrapper">
                        <div className="inhouse-main-wrap">
                          <p> In house</p>
                          <div className="disable-twofa-input-wrap">
                            <input
                              type="checkbox"
                              id="inHouseSwitch"
                              checked={isInhouseChecked}
                              onChange={toggleChecked}
                            />
                            <label for="inHouseSwitch">Toggle</label>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="profile-edit-application-dropdown">
                      <Dropdown
                        onTypeChange={handleDropdownChange("ApplicationStatus")}
                        label="Application"
                        data={ApplicationStatusDropdown}
                        alreadyValue={
                          userDetail?.interviewStatus == true
                            ? "Approved"
                            : userDetail?.interviewStatus == false
                            ? "Rejected"
                            : ""
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="edit-profile-address-wrapper">
                <div className="edit-profile-address-wrap">
                  {shimmerLoading ? (
                    <ShimmerThumbnail rounded />
                  ) : (
                    <div className="edit-profile-address-left edit-profile-main-left-wrap">
                      <h4>Business and Address Info </h4>

                      <div className="edit-address-main-wrap">
                        <div className="edit-address-repeat">
                          <div className="edit-address-left">
                            <p>Name</p>
                          </div>
                          <div className="edit-address-right">
                            <p>{userDetail?.fullName}</p>
                          </div>
                        </div>

                        <div className="edit-address-repeat">
                          <div className="edit-address-left">
                            <p>Phone Number</p>
                          </div>
                          <div className="edit-address-right">
                            <p>{userDetail?.phone}</p>
                          </div>
                        </div>

                        <div className="edit-address-repeat">
                          <div className="edit-address-left">
                            <p>Country:</p>
                          </div>
                          <div className="edit-address-right">
                            <p>{userDetail?.country}</p>
                          </div>
                        </div>

                        <div className="edit-address-repeat">
                          <div className="edit-address-left">
                            <p>Street Address</p>
                          </div>
                          <div className="edit-address-right">
                            <p>{userDetail?.address}</p>
                          </div>
                        </div>

                        <div className="edit-address-repeat">
                          <div className="edit-address-left">
                            <p>City:</p>
                          </div>
                          <div className="edit-address-right">
                            <p>{userDetail?.city}</p>
                          </div>
                        </div>

                        <div className="edit-address-repeat">
                          <div className="edit-address-left">
                            <p>Province:</p>
                          </div>
                          <div className="edit-address-right">
                            <p>{userDetail?.province}</p>
                          </div>
                        </div>

                        <div className="edit-address-repeat">
                          <div className="edit-address-left">
                            <p>Postal Code:</p>
                          </div>
                          <div className="edit-address-right">
                            <p>{userDetail?.postalCode}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {shimmerLoading ? (
                    <ShimmerThumbnail rounded />
                  ) : (
                    <div className="edit-profile-address-left">
                      <h4> City to service</h4>
                      <div className="city-services-select-wrap">
                        <MultiSelect
                          items={ServicesData}
                          selectedItems={selectedCity}
                          handleChange={handleChange}
                          itemType="servicesCities"
                          userDetail={userDetail}
                        />
                      </div>

                      <h4>
                        {" "}
                        Employment Status: {userDetail?.employementStatus}
                      </h4>

                      {userDetail?.employementStatus == "employee" ? (
                        <div className="login-option socail-sin-number-input">
                          <form autoComplete="off">
                            <InputField
                              type="number"
                              name="insuranceNo"
                              id="password"
                              value={sinNumber}
                              label="Social Insurance Number (SIN)"
                              passwordIcon={false}
                              onChange={(e) => setSinNumber(e.target.value)}
                            />
                          </form>
                        </div>
                      ) : (
                        <div className="contractor-certificate-wrap">
                          <div className="certificate-upload-box">
                            {businessUploadLoading ? (
                              <p> Document Uploading...</p>
                            ) : (
                              <>
                                <p
                                  className={
                                    bussinessPath
                                      ? "upload-lable active"
                                      : "upload-lable"
                                  }
                                >
                                  Business Registration
                                </p>

                                <p className="link-path-style">
                                  <a href={bussinessPath} target="_blank">
                                    {bussinessPath && bussinessPath}
                                  </a>
                                </p>
                              </>
                            )}

                            <div className="upload-icon-wrap">
                              {!bussinessPath && (
                                <input
                                  type="file"
                                  onChange={handleFileChange}
                                />
                              )}

                              {bussinessPath ? (
                                <img
                                  onClick={() => setBussinessPath("")}
                                  src="./images/icons/remove-icon.png"
                                  alt="icon"
                                />
                              ) : (
                                <img
                                  src="./images/icons/uploaded-icon.png"
                                  alt="icon"
                                />
                              )}
                            </div>
                          </div>

                          <div className="certificate-upload-box">
                            {gstUploadLoading ? (
                              <p> Document Uploading...</p>
                            ) : (
                              <>
                                <p
                                  className={
                                    gstPath
                                      ? "upload-lable active"
                                      : "upload-lable"
                                  }
                                >
                                  Proof of GST Number
                                </p>

                                <p className="link-path-style">
                                  <a href={gstPath} target="_blank">
                                    {gstPath && gstPath}
                                  </a>
                                </p>
                              </>
                            )}

                            <div className="upload-icon-wrap">
                              {!gstPath && (
                                <input type="file" onChange={handleGstChange} />
                              )}

                              {gstPath ? (
                                <img
                                  onClick={() => setGstPath("")}
                                  src="./images/icons/remove-icon.png"
                                  alt="icon"
                                />
                              ) : (
                                <img
                                  src="./images/icons/uploaded-icon.png"
                                  alt="icon"
                                />
                              )}
                            </div>
                          </div>

                          <div className="certificate-upload-box">
                            {liabilityUploadLoading ? (
                              <p> Document Uploading...</p>
                            ) : (
                              <>
                                <p
                                  className={
                                    insurancePath
                                      ? "upload-lable active"
                                      : "upload-lable"
                                  }
                                >
                                  Liability Insurance
                                </p>

                                <p className="link-path-style">
                                  <a href={insurancePath} target="_blank">
                                    {insurancePath && insurancePath}
                                  </a>
                                </p>
                              </>
                            )}

                            <div className="upload-icon-wrap">
                              {!insurancePath && (
                                <input
                                  type="file"
                                  onChange={handleInsuranceChange}
                                />
                              )}

                              {insurancePath ? (
                                <img
                                  onClick={() => setInsurancePath("")}
                                  src="./images/icons/remove-icon.png"
                                  alt="icon"
                                />
                              ) : (
                                <img
                                  src="./images/icons/uploaded-icon.png"
                                  alt="icon"
                                />
                              )}
                            </div>
                          </div>

                          <div className="certificate-upload-box">
                            {whimsUploadLoading ? (
                              <p> Document Uploading...</p>
                            ) : (
                              <>
                                <p
                                  className={
                                    whimsPath
                                      ? "upload-lable active"
                                      : "upload-lable"
                                  }
                                >
                                  WHIMS Registration
                                </p>

                                <p className="link-path-style">
                                  <a href={whimsPath} target="_blank">
                                    {whimsPath && whimsPath}
                                  </a>
                                </p>
                              </>
                            )}

                            <div className="upload-icon-wrap">
                              {!whimsPath && (
                                <input
                                  type="file"
                                  onChange={handleWhimsChange}
                                />
                              )}

                              {whimsPath ? (
                                <img
                                  onClick={() => setWhimsPath("")}
                                  src="./images/icons/remove-icon.png"
                                  alt="icon"
                                />
                              ) : (
                                <img
                                  src="./images/icons/uploaded-icon.png"
                                  alt="icon"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </>

            <div className="edit-profile-services-wrapper">
              <h4> Services: Commercial and Residential </h4>
              <div className="edit-profile-services-wrap">
                {shimmerLoading ? (
                  <>
                    <ShimmerThumbnail rounded />
                    <ShimmerThumbnail rounded />
                  </>
                ) : (
                  <>
                    <div className="edit-profile-service-left">
                      <div className="edit-profile-service-header">
                        <div className="edit-profile-service-head-left">
                          <img
                            src="./images/icons/commerical-icon.png"
                            alt="icon"
                          />
                          <p>Commercail</p>
                        </div>
                        <div className="edit-profile-service-head-right">
                          <img
                            onClick={handleShowCommerical}
                            src="./images/icons/edit-icon.png"
                            alt="icon"
                          />
                        </div>
                      </div>
                      <div className="commerical-services-wrap">
                        <h4> Services</h4>
                        <div className="profile-commerical-services-select-wrap">
                          {selectedComServices?.map((data, index) => {
                            return (
                              <>
                                {data.name?.length > 12 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id={`tooltip-up`} className="">
                                        {data.name}
                                      </Tooltip>
                                    }
                                  >
                                    <p> {data.name}</p>
                                  </OverlayTrigger>
                                ) : (
                                  <p> {data.name}</p>
                                )}
                              </>
                            );
                          })}
                        </div>
                      </div>

                      <div className="commerical-services-wrap commerical-specility-wrap">
                        <h4> Speciality</h4>
                        <div className="profile-commerical-speciality-select-wrap">
                          {selectedComSpeciality?.map((data, index) => {
                            return (
                              <>
                                {data.name?.length > 12 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id={`tooltip-up`} className="">
                                        {data.name}
                                      </Tooltip>
                                    }
                                  >
                                    <p> {data.name}</p>
                                  </OverlayTrigger>
                                ) : (
                                  <p> {data.name}</p>
                                )}
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    <div className="edit-profile-service-left">
                      <div className="edit-profile-service-header">
                        <div className="edit-profile-service-head-left">
                          <img
                            src="./images/icons/residental-icon.png"
                            alt="icon"
                          />

                          <p>Residental</p>
                        </div>
                        <div className="edit-profile-service-head-right">
                          <img
                            onClick={handleShowResidential}
                            src="./images/icons/edit-icon.png"
                            alt="icon"
                          />
                        </div>
                      </div>
                      <div className="commerical-services-wrap">
                        <h4> Services</h4>
                        <div className="profile-commerical-services-select-wrap">
                          {selectedResidentailServices?.map((data, index) => {
                            return (
                              <>
                                {data.name?.length > 12 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id={`tooltip-up`} className="">
                                        {data.name}
                                      </Tooltip>
                                    }
                                  >
                                    <p> {data.name}</p>
                                  </OverlayTrigger>
                                ) : (
                                  <p> {data.name}</p>
                                )}
                              </>
                            );
                          })}
                        </div>
                      </div>

                      <div className="commerical-services-wrap commerical-specility-wrap">
                        <h4> Speciality</h4>
                        <div className="profile-commerical-speciality-select-wrap">
                          {selectedResidentailSpeciality?.map((data, index) => {
                            return (
                              <>
                                {data.name?.length > 12 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id={`tooltip-up`} className="">
                                        {data.name}
                                      </Tooltip>
                                    }
                                  >
                                    <p> {data.name}</p>
                                  </OverlayTrigger>
                                ) : (
                                  <p> {data.name}</p>
                                )}
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {shimmerLoading ? (
              <div className="availabilty-shimmer-wrap">
                <ShimmerThumbnail rounded />
              </div>
            ) : (
              <div className="edit-profile-availabilty-wrapper">
                <div className="edit-profile-availabilty-header">
                  <h4>Availability </h4>
                  <img
                    onClick={handleShowAvailabity}
                    src="./images/icons/edit-icon.png"
                    alt="icon"
                  />
                </div>
                <div className="availability-slots-grid">
                  {availabiltyData &&
                    Object.keys(availabiltyData)?.map((dayKey) => (
                      <div key={dayKey} className="availability-day-slot-wrap">
                        <p>
                          {daysOfWeek[dayKey]} <span> : </span>{" "}
                        </p>
                        <div className="availability-time-slot-wrap">
                          {availabiltyData[dayKey]?.map((slot, index) => (
                            <div
                              key={slot.id}
                              className={`time-slot ${
                                index > 0 ? "additional-slot" : ""
                              }`}
                            >
                              {slot.startTime && slot.endTime ? (
                                <>
                                  {convertTo12HourFormat(slot.startTime)} to{" "}
                                  {convertTo12HourFormat(slot.endTime)}
                                </>
                              ) : (
                                <span>No availability</span>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            <div className="edit-profile-testing-wrapper">
              <div className="edit-profile-testing-wrap">
                {shimmerLoading ? (
                  <>
                    <ShimmerThumbnail rounded />
                    <ShimmerThumbnail rounded />
                    <ShimmerThumbnail rounded />
                  </>
                ) : (
                  <>
                    <div className="edit-profile-repeat-wrap">
                      <h4> Safety Testing </h4>

                      <div className="contractor-testing-certificate-wrap">
                        <h5>OHSA Training </h5>
                        <div className="certificate-upload-box">
                          {docUploadLoading ? (
                            <p> Upload Document...</p>
                          ) : (
                            <>
                              <p
                                className={
                                  ohsaCerificatePath
                                    ? "upload-lable ohsa-certificate-text active"
                                    : "upload-lable ohsa-certificate-text"
                                }
                              >
                                Upload OHSA certificate
                              </p>

                              <p className="link-path-style">
                                <a href={ohsaCerificatePath} target="_blank">
                                  {" "}
                                  {ohsaCerificatePath && ohsaCerificatePath}
                                </a>
                              </p>
                            </>
                          )}

                          <div className="upload-icon-wrap">
                            {!ohsaCerificatePath && (
                              <input
                                type="file"
                                onChange={handleOhsaFileChange}
                              />
                            )}

                            {ohsaCerificatePath ? (
                              <img
                                onClick={() => setOhsaCertificatePath("")}
                                src="./images/icons/remove-icon.png"
                                alt="icon"
                              />
                            ) : (
                              <img
                                src="./images/icons/uploaded-icon.png"
                                alt="icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="contractor-testing-certificate-wrap">
                        <h5>WHMIS Quiz </h5>

                        <div className="whmis-quiz-wrap">
                          <div className="qize-left-wrap">
                            <p> Quiz Score: </p>
                          </div>
                          <div className="qize-right-wrap">
                            <h6>
                              <span> {userDetail?.quizNumber}</span>/99
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="edit-profile-repeat-wrap">
                      <div className="bank-detail-header-wrap inhouse-main-wrapper ">
                        <h4> Bank Details</h4>
                        <div className="bank-check-approved-wrap">
                          <p> Approved:</p>
                          <div className="disable-twofa-input-wrap">
                            <input
                              type="checkbox"
                              id="banckSwitch"
                              checked={isBankChecked}
                              onChange={toggleBankApprove}
                            />
                            <label for="banckSwitch">Toggle</label>
                          </div>
                        </div>
                      </div>

                      <div className="contractor-testing-certificate-wrap">
                        <h5>Upload Cheque </h5>
                        <div className="certificate-upload-box">
                          {docBankLoading ? (
                            <p> Upload Document...</p>
                          ) : (
                            <>
                              <p
                                className={
                                  bankChequePath
                                    ? "upload-lable ohsa-certificate-text active"
                                    : "upload-lable ohsa-certificate-text"
                                }
                              >
                                Upload Cheque
                              </p>

                              <p className="link-path-style">
                                <a href={bankChequePath} target="_blank">
                                  {bankChequePath && bankChequePath}
                                </a>
                              </p>
                            </>
                          )}

                          <div className="upload-icon-wrap">
                            {!bankChequePath && (
                              <input
                                type="file"
                                onChange={handleBankFileChange}
                              />
                            )}

                            {bankChequePath ? (
                              <img
                                onClick={() => setBanChequePath("")}
                                src="./images/icons/remove-icon.png"
                                alt="icon"
                              />
                            ) : (
                              <img
                                src="./images/icons/uploaded-icon.png"
                                alt="icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="bank-detail-header-wrap crimnal-check-main-wrap inhouse-main-wrapper ">
                        <h4> Criminal Check </h4>
                        {/* <div className="bank-check-approved-wrap">
                      <p> Approved:</p>
                      <div className="disable-twofa-input-wrap">
                        <input
                          type="checkbox"
                          id="crimalSwitch"
                          checked={isCrimnalChecked}
                          onChange={toggleCrimnalApprove}
                        />
                        <label for="crimalSwitch">Toggle</label>
                      </div>
                    </div> */}
                      </div>

                      <div className="contractor-testing-certificate-wrap">
                        <h5>Upload documents </h5>
                        <div className="certificate-upload-box">
                          {crimnalCheckLoading ? (
                            <p> Upload Document...</p>
                          ) : (
                            <>
                              <p
                                className={
                                  crimnalCheckPath
                                    ? "upload-lable ohsa-certificate-text active"
                                    : "upload-lable ohsa-certificate-text"
                                }
                              >
                                Government-Issued ID
                              </p>

                              <p className="link-path-style">
                                <a href={crimnalCheckPath} target="_blank">
                                  {crimnalCheckPath && crimnalCheckPath}
                                </a>
                              </p>
                            </>
                          )}

                          <div className="upload-icon-wrap">
                            {!crimnalCheckPath && (
                              <input
                                type="file"
                                onChange={handleCrimnalFileChange}
                              />
                            )}

                            {crimnalCheckPath ? (
                              <img
                                onClick={() => setCrimnalCheckPath("")}
                                src="./images/icons/remove-icon.png"
                                alt="icon"
                              />
                            ) : (
                              <img
                                src="./images/icons/uploaded-icon.png"
                                alt="icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="edit-profile-repeat-wrap">
                      <h4> Interview time</h4>

                      <div className="schedule-main-wrap interview-schedule-time-wrap">
                        <div className="date-and-time-wrapper">
                          <div className="date-input-wrap">
                            <DatePicker
                              minDate={new Date()}
                              maxDate={moment().add(30, "days").toDate()}
                              selected={selectedDate}
                              onChange={(date) => handleDateChange(date)}
                              customInput={
                                <div className="custom-date-input">
                                  <img
                                    src="./images/icons/date.svg"
                                    alt="icon"
                                    className="datepicker-icon"
                                  />
                                  <p>Date</p>
                                  <input
                                    type="text"
                                    placeholder="Select date"
                                    value={
                                      selectedDate
                                        ? moment(selectedDate).format(
                                            "DD MMM YYYY"
                                          )
                                        : ""
                                    }
                                    readOnly
                                  />
                                </div>
                              }
                            />
                          </div>

                          <TimePicker disabled={!selectedDate} />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="edit-profile-save-button">
              <Button
                label="Save"
                isLoading={isLoading}
                onClick={saveProfileInfoHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
